import * as React from "react";
import { forwardRef } from "react";
const SvgIconDocument = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6.25 4v12.75h1.5V5.5H19v14.25a.75.75 0 1 1-1.5 0V17.5H4v2.25A2.26 2.26 0 0 0 6.25 22h12a2.26 2.26 0 0 0 2.25-2.25V4zM5.5 19H16v.75a2.2 2.2 0 0 0 .141.75H6.25a.737.737 0 0 1-.75-.75z", "data-name": "icon/document", transform: "translate(-3.25 -4)", fill: "#57728a" }));
const ForwardRef = forwardRef(SvgIconDocument);
export { ForwardRef as ReactComponent };
